import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiCheck, FiStar, FiPlay } from 'react-icons/fi';
import CourseCard from '../components/CourseCard';
import { getCourses, getTestimonials } from '../utils/api';

const stats = [
  { value: '500+', label: 'Students Trained' },
  { value: '95%', label: 'Placement Rate' },
  { value: '3', label: 'Job-Ready Programs' },
  { value: '40+', label: 'Hiring Partners' },
];

const features = [
  { icon: '🎯', title: 'Industry-Designed Curriculum', desc: 'Built with input from engineers at top companies. Learn exactly what employers want.' },
  { icon: '💼', title: 'Paid Internship Included', desc: 'Every student gets a 1-month internship with real projects and a verified certificate.' },
  { icon: '🚀', title: 'Placement Assistance', desc: 'Resume reviews, mock interviews, LinkedIn optimization, and direct referrals to our hiring partners.' },
  { icon: '🧑‍🏫', title: 'Expert Mentors', desc: 'Learn from working professionals with 5–10 years of industry experience at top tech companies.' },
  { icon: '🛠️', title: 'Hands-On Projects', desc: 'Build a portfolio of 3–5 real projects that showcase your skills to employers.' },
  { icon: '📜', title: 'Dual Certificate', desc: 'Receive both a course completion certificate and a verified internship certificate.' },
];

const companies = ['Google', 'Microsoft', 'Infosys', 'Wipro', 'TCS', 'Razorpay', 'Zomato', 'Swiggy', 'ISRO', 'Accenture'];

export default function HomePage() {
  const [courses, setCourses] = useState([]);
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    getCourses().then(r => setCourses(r.data.courses || [])).catch(() => {});
    getTestimonials().then(r => setTestimonials(r.data.testimonials || [])).catch(() => {});
  }, []);

  return (
    <div>
      <style>{`
        /* ── Hero ── */
        .hero { min-height: 100vh; display: flex; align-items: center; background: linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #1a1f35 100%); position: relative; overflow: hidden; padding-top: 70px; }
        .hero::before { content: ''; position: absolute; inset: 0; background: radial-gradient(ellipse 80% 60% at 60% 40%, rgba(26,86,219,0.25), transparent), radial-gradient(ellipse 50% 50% at 20% 80%, rgba(232,89,12,0.15), transparent); }
        .hero-dots { position: absolute; inset: 0; background-image: radial-gradient(rgba(255,255,255,0.06) 1px, transparent 1px); background-size: 32px 32px; }
        .hero-inner { max-width: 1180px; margin: 0 auto; padding: 80px 24px; display: grid; grid-template-columns: 1fr 1fr; gap: 64px; align-items: center; position: relative; z-index: 1; }
        .hero-label { display: inline-flex; align-items: center; gap: 8px; background: rgba(26,86,219,0.2); border: 1px solid rgba(26,86,219,0.3); color: #93c5fd; padding: 6px 16px; border-radius: 999px; font-size: 13px; font-weight: 600; font-family: var(--font-display); margin-bottom: 20px; }
        .hero-label::before { content: ''; width: 6px; height: 6px; background: var(--accent); border-radius: 50%; animation: pulse 2s infinite; }
        .hero-title { font-size: clamp(32px, 5vw, 52px); color: white; line-height: 1.15; margin-bottom: 20px; }
        .hero-title span { color: var(--accent); }
        .hero-desc { color: #94a3b8; font-size: 17px; line-height: 1.7; margin-bottom: 32px; }
        .hero-actions { display: flex; gap: 14px; flex-wrap: wrap; margin-bottom: 40px; }
        .hero-trust { display: flex; align-items: center; gap: 12px; }
        .hero-trust-avatars { display: flex; }
        .hero-avatar { width: 34px; height: 34px; border-radius: 50%; border: 2px solid #1e3a5f; display: flex; align-items: center; justify-content: center; font-size: 14px; margin-left: -8px; background: linear-gradient(135deg, var(--primary), var(--accent)); color: white; font-weight: 700; }
        .hero-avatar:first-child { margin-left: 0; }
        .hero-trust-text { font-size: 13px; color: #94a3b8; }
        .hero-trust-text strong { color: white; }
        .hero-card { background: rgba(255,255,255,0.05); backdrop-filter: blur(20px); border: 1px solid rgba(255,255,255,0.1); border-radius: var(--radius-xl); padding: 28px; }
        .hero-card-title { font-size: 15px; font-weight: 600; color: white; margin-bottom: 16px; display: flex; align-items: center; gap: 8px; }
        .hero-course-item { display: flex; align-items: center; gap: 14px; padding: 14px; background: rgba(255,255,255,0.05); border-radius: var(--radius); margin-bottom: 10px; border: 1px solid rgba(255,255,255,0.08); cursor: pointer; transition: var(--transition); }
        .hero-course-item:hover { background: rgba(26,86,219,0.2); border-color: rgba(26,86,219,0.4); }
        .hero-course-icon { width: 44px; height: 44px; border-radius: 12px; display: flex; align-items: center; justify-content: center; font-size: 22px; flex-shrink: 0; }
        .hero-course-info h4 { color: white; font-size: 14px; font-weight: 600; margin-bottom: 2px; }
        .hero-course-info p { color: #94a3b8; font-size: 12px; }
        .hero-course-fee { margin-left: auto; text-align: right; }
        .hero-course-fee .fee { color: white; font-weight: 700; font-size: 14px; font-family: var(--font-display); }
        .hero-course-fee .reg { color: var(--accent); font-size: 11px; }
        .hero-floating-badge { display: inline-flex; align-items: center; gap: 6px; background: rgba(5,150,105,0.2); border: 1px solid rgba(5,150,105,0.3); color: #6ee7b7; padding: 8px 16px; border-radius: var(--radius); font-size: 13px; font-weight: 500; margin-top: 14px; }

        /* ── Stats Bar ── */
        .stats-bar { background: var(--dark-2); padding: 32px 0; }
        .stats-inner { max-width: 1180px; margin: 0 auto; padding: 0 24px; display: grid; grid-template-columns: repeat(4, 1fr); gap: 24px; text-align: center; }
        .stat-item {}
        .stat-value { font-size: 32px; font-weight: 800; font-family: var(--font-display); color: white; }
        .stat-value span { color: var(--accent); }
        .stat-label { font-size: 13px; color: #94a3b8; margin-top: 2px; }

        /* ── Features ── */
        .features-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; margin-top: 48px; }
        .feature-card { padding: 28px; background: white; border-radius: var(--radius-lg); border: 1px solid var(--border); transition: var(--transition); }
        .feature-card:hover { border-color: var(--primary); box-shadow: var(--shadow-md); transform: translateY(-3px); }
        .feature-icon { font-size: 32px; margin-bottom: 14px; }
        .feature-card h3 { font-size: 16px; margin-bottom: 8px; }
        .feature-card p { font-size: 14px; color: var(--mid); line-height: 1.6; }

        /* ── Companies ── */
        .companies-section { background: var(--bg); padding: 48px 0; text-align: center; }
        .companies-label { font-size: 13px; color: var(--mid); font-weight: 500; margin-bottom: 24px; }
        .companies-scroll { display: flex; gap: 32px; justify-content: center; flex-wrap: wrap; }
        .company-tag { font-family: var(--font-display); font-weight: 700; font-size: 15px; color: var(--light); letter-spacing: 0.5px; }

        /* ── Testimonials ── */
        .testimonials-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; margin-top: 48px; }
        .testimonial-card { background: white; border-radius: var(--radius-lg); padding: 28px; border: 1px solid var(--border); transition: var(--transition); }
        .testimonial-card:hover { box-shadow: var(--shadow-md); transform: translateY(-3px); }
        .testimonial-stars { display: flex; gap: 3px; margin-bottom: 14px; }
        .testimonial-content { font-size: 14px; color: var(--dark-3); line-height: 1.7; margin-bottom: 20px; font-style: italic; }
        .testimonial-author { display: flex; align-items: center; gap: 12px; }
        .testimonial-avatar { width: 44px; height: 44px; border-radius: 50%; background: linear-gradient(135deg, var(--primary), var(--accent)); display: flex; align-items: center; justify-content: center; color: white; font-weight: 700; font-size: 16px; flex-shrink: 0; }
        .testimonial-author-info h4 { font-size: 14px; font-weight: 600; margin-bottom: 2px; }
        .testimonial-author-info p { font-size: 12px; color: var(--mid); }
        .testimonial-course-tag { display: inline-block; background: var(--primary-light); color: var(--primary); font-size: 11px; font-weight: 600; padding: 2px 8px; border-radius: 4px; margin-top: 4px; }

        /* ── CTA Section ── */
        .cta-section { background: linear-gradient(135deg, var(--primary) 0%, #1e40af 100%); padding: 80px 0; position: relative; overflow: hidden; }
        .cta-section::before { content: ''; position: absolute; inset: 0; background: radial-gradient(ellipse at 80% 50%, rgba(232,89,12,0.2), transparent); }
        .cta-inner { max-width: 700px; margin: 0 auto; padding: 0 24px; text-align: center; position: relative; z-index: 1; }
        .cta-inner h2 { font-size: clamp(28px, 4vw, 40px); color: white; margin-bottom: 14px; }
        .cta-inner p { color: rgba(255,255,255,0.8); font-size: 17px; margin-bottom: 32px; }
        .cta-actions { display: flex; gap: 14px; justify-content: center; flex-wrap: wrap; }
        .cta-checks { display: flex; gap: 24px; justify-content: center; margin-top: 24px; flex-wrap: wrap; }
        .cta-check { display: flex; align-items: center; gap: 6px; color: rgba(255,255,255,0.8); font-size: 14px; }

        @media (max-width: 900px) {
          .hero-inner { grid-template-columns: 1fr; gap: 40px; }
          .stats-inner { grid-template-columns: repeat(2, 1fr); }
          .features-grid { grid-template-columns: repeat(2, 1fr); }
          .testimonials-grid { grid-template-columns: 1fr; }
        }
        @media (max-width: 600px) {
          .stats-inner { grid-template-columns: repeat(2, 1fr); }
          .features-grid { grid-template-columns: 1fr; }
          .hero-actions { flex-direction: column; }
        }
      `}</style>

      {/* HERO */}
      <section className="hero">
        <div className="hero-dots" />
        <div className="hero-inner">
          <div style={{ animation: 'fadeInUp 0.7s ease' }}>
            <div className="hero-label">🎓 Korpnex EdTech — Bengaluru</div>
            <h1 className="hero-title">
              Go from College<br />to <span>Industry-Ready</span><br />in 3 Months
            </h1>
            <p className="hero-desc">
              Hands-on training programs with real projects, paid internship, and placement assistance. Built for college students and freshers who want to launch their careers fast.
            </p>
            <div className="hero-actions">
              <Link to="/apply" className="btn btn-accent btn-lg">Apply Now — It's Free <FiArrowRight /></Link>
              <Link to="/courses" className="btn btn-white btn-lg"><FiPlay size={16} /> Explore Programs</Link>
            </div>
            <div className="hero-trust">
              <div className="hero-trust-avatars">
                {['R','A','S','P','M'].map((l,i) => <div key={i} className="hero-avatar">{l}</div>)}
              </div>
              <div className="hero-trust-text">
                <strong>500+ students</strong> already enrolled<br />
                <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                  {[...Array(5)].map((_,i) => <FiStar key={i} size={12} fill="#f59e0b" color="#f59e0b" />)}
                  <span>4.9 avg rating</span>
                </div>
              </div>
            </div>
          </div>

          <div style={{ animation: 'fadeInUp 0.9s ease' }}>
            <div className="hero-card">
              <div className="hero-card-title">🚀 Our Programs</div>
              {[
                { icon: '💻', title: 'Full Stack Web Dev', sub: '3 Months · React + Node', fee: '₹15,000', reg: 'Start at ₹2,000', bg: '#dbeafe' },
                { icon: '🤖', title: 'Data Science & AI', sub: '3 Months · Python + ML', fee: '₹18,000', reg: 'Start at ₹2,000', bg: '#f3e8ff' },
                { icon: '📱', title: 'Digital Marketing', sub: '2 Months · SEO + Ads', fee: '₹12,000', reg: 'Start at ₹2,000', bg: '#fef3c7' },
              ].map((c, i) => (
                <Link to="/courses" key={i} style={{ textDecoration: 'none' }}>
                  <div className="hero-course-item">
                    <div className="hero-course-icon" style={{ background: c.bg }}>{c.icon}</div>
                    <div className="hero-course-info"><h4>{c.title}</h4><p>{c.sub}</p></div>
                    <div className="hero-course-fee"><div className="fee">{c.fee}</div><div className="reg">{c.reg}</div></div>
                  </div>
                </Link>
              ))}
              <div className="hero-floating-badge">
                <FiCheck size={14} /> Internship + Placement assistance included
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* STATS */}
      <div className="stats-bar">
        <div className="stats-inner">
          {stats.map((s, i) => (
            <div key={i} className="stat-item">
              <div className="stat-value">{s.value}</div>
              <div className="stat-label">{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* COMPANIES */}
      <div className="companies-section">
        <div className="container">
          <p className="companies-label">Our students have been placed at</p>
          <div className="companies-scroll">
            {companies.map(c => <div key={c} className="company-tag">{c}</div>)}
          </div>
        </div>
      </div>

      {/* COURSES */}
      <section className="section" style={{ background: 'var(--bg)' }}>
        <div className="container">
          <div className="text-center" style={{ marginBottom: 48 }}>
            <div className="section-label">Our Programs</div>
            <h2 className="section-title">3 Career-Defining <span>Programs</span></h2>
            <p className="section-subtitle" style={{ margin: '0 auto' }}>
              Each program is designed to take you from beginner to job-ready in 2–3 months with real projects and guaranteed internship.
            </p>
          </div>
          <div className="grid-3">
            {courses.map(c => <CourseCard key={c._id} course={c} />)}
          </div>
          <div className="text-center" style={{ marginTop: 40 }}>
            <Link to="/apply" className="btn btn-accent btn-lg">Apply for a Program <FiArrowRight /></Link>
          </div>
        </div>
      </section>

      {/* WHY KRUTANIC */}
      <section className="section">
        <div className="container">
          <div className="text-center" style={{ marginBottom: 0 }}>
            <div className="section-label">Why Korpnex</div>
            <h2 className="section-title">Everything You Need to <span>Get Hired</span></h2>
            <p className="section-subtitle" style={{ margin: '0 auto' }}>
              We don't just teach — we mentor, connect, and place. Here's what sets Korpnex apart from the rest.
            </p>
          </div>
          <div className="features-grid">
            {features.map((f, i) => (
              <div key={i} className="feature-card">
                <div className="feature-icon">{f.icon}</div>
                <h3>{f.title}</h3>
                <p>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      {testimonials.length > 0 && (
        <section className="section" style={{ background: 'var(--bg)' }}>
          <div className="container">
            <div className="text-center" style={{ marginBottom: 0 }}>
              <div className="section-label">Success Stories</div>
              <h2 className="section-title">Students Who <span>Made It</span></h2>
              <p className="section-subtitle" style={{ margin: '0 auto' }}>Real results from real students. Don't just take our word for it.</p>
            </div>
            <div className="testimonials-grid">
              {testimonials.slice(0, 6).map((t, i) => (
                <div key={i} className="testimonial-card">
                  <div className="testimonial-stars">
                    {[...Array(t.rating || 5)].map((_, j) => <FiStar key={j} size={14} fill="#f59e0b" color="#f59e0b" />)}
                  </div>
                  <p className="testimonial-content">"{t.content}"</p>
                  <div className="testimonial-author">
                    <div className="testimonial-avatar">{t.name[0]}</div>
                    <div className="testimonial-author-info">
                      <h4>{t.name}</h4>
                      <p>{t.role}</p>
                      <div className="testimonial-course-tag">{t.course}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* CTA */}
      <section className="cta-section">
        <div className="cta-inner">
          <div className="section-label" style={{ background: 'rgba(255,255,255,0.15)', color: 'white' }}>Limited Seats Available</div>
          <h2>Ready to Launch Your Career?</h2>
          <p>Applications are open for the next batch. Spots fill fast — apply today and take the first step toward your dream tech job.</p>
          <div className="cta-actions">
            <Link to="/apply" className="btn btn-accent btn-lg">Apply Now — Free <FiArrowRight /></Link>
            <Link to="/courses" className="btn btn-white btn-lg">View All Programs</Link>
          </div>
          <div className="cta-checks">
            {['Free Application', 'Pay ₹2,000 on Approval', 'Internship Guaranteed', 'Placement Support'].map((c, i) => (
              <div key={i} className="cta-check"><FiCheck size={15} /> {c}</div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}